import * as Yup from 'yup';

export const EMAIL_LIST_SEPARATOR = ';';

const EMAIL_REGEX =
  /^[A-Za-z0-9_%+-]+(?:\.[A-Za-z0-9_%+-]+)*@[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?(?:\.[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?)+$/;

export const isValidEmail = (value) => EMAIL_REGEX.test(value);

export const isValidEmailList = (value) => {
  if (!value) return true;
  return value.split(EMAIL_LIST_SEPARATOR).every(isValidEmail);
};

export const sanitizeEmailListInput = (value) =>
  (value ?? '').replace(/\s+/g, '').replace(/;{2,}/g, ';').replace(/^;/, '');

export const emailListSchema = (message) =>
  Yup.string().test('email-list', message, (value) => isValidEmailList(value));
